/**
 * IST date formatting helpers (Msg 1066, Feb 2026).
 *
 * The backend stores all timestamps in UTC (ISO 8601 with "Z" or offset).
 * The user wants every display surface to render in Indian Standard Time.
 * These helpers do the conversion in one place so the rest of the codebase
 * can stop slicing raw ISO strings.
 */
const IST_TZ = "Asia/Kolkata";

function toDate(value) {
  if (!value) return null;
  if (value instanceof Date) return isNaN(value.getTime()) ? null : value;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
}

/** "2026-05-18 17:42" — minute precision, 24h, IST. */
export function fmtIST(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleString("en-IN", {
    timeZone: IST_TZ,
    year: "numeric", month: "2-digit", day: "2-digit",
    hour: "2-digit", minute: "2-digit", hour12: false,
  }).replace(",", "");
}

/** "18 May 2026, 5:42 PM IST" — human-readable, 12h, IST. */
export function fmtISTNice(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleString("en-IN", {
    timeZone: IST_TZ,
    day: "2-digit", month: "short", year: "numeric",
    hour: "numeric", minute: "2-digit", hour12: true,
  }) + " IST";
}

/** "18 May 2026" — date only, IST. */
export function fmtISTDate(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleDateString("en-IN", {
    timeZone: IST_TZ,
    day: "2-digit", month: "short", year: "numeric",
  });
}

/** "5:42 PM" — time only, IST. */
export function fmtISTTime(value) {
  const d = toDate(value);
  if (!d) return "";
  return d.toLocaleTimeString("en-IN", {
    timeZone: IST_TZ,
    hour: "numeric", minute: "2-digit", hour12: true,
  });
}

/** "2h ago", "3d ago" — relative IST. */
export function fmtRel(value) {
  const d = toDate(value);
  if (!d) return "";
  const diff = Date.now() - d.getTime();
  const m = Math.round(diff / 60000);
  if (m < 1) return "just now";
  if (m < 60) return `${m}m ago`;
  const h = Math.round(m / 60);
  if (h < 24) return `${h}h ago`;
  const days = Math.round(h / 24);
  if (days < 30) return `${days}d ago`;
  const mo = Math.round(days / 30);
  return `${mo}mo ago`;
}
